import axios from "axios";
import type { AxiosInstance } from "axios";

export interface SubmitCpfRequest {
  cpf: string;
}

export interface SubmitCpfResponse {
  success: boolean;
  data?: any;
  message?: string;
  requestId?: string;
}

const API_BASE_URL = import.meta.env.VITE_API_URL || "http://localhost:3001";

// Configuração do axios com CORS e credentials
const axiosInstance: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// Interceptor de requisição para garantir que os cookies sejam enviados
axiosInstance.interceptors.request.use(
  (config) => {
    config.withCredentials = true;

    if (typeof document !== "undefined" && import.meta.env.DEV) {
      const cookies = document.cookie;
      console.log("[cpfApi] Cookies disponíveis:", cookies);
      console.log("[cpfApi] URL da requisição:", config.url);
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Interceptor de resposta para debug
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      console.error("[cpfApi] Erro na resposta:", {
        status: error.response.status,
        statusText: error.response.statusText,
        data: error.response.data,
        headers: error.response.headers,
      });
    }
    return Promise.reject(error);
  },
);

export async function submitCpf(
  data: SubmitCpfRequest,
): Promise<SubmitCpfResponse> {
  try {
    const response = await axiosInstance.patch<SubmitCpfResponse>(
      "/checklist/cpf",
      data,
    );
    return response.data;
  } catch (error: any) {
    if (error.response) {
      const status = error.response.status;
      const statusText = error.response.statusText;
      const errorMessage = error.response.data?.message ||
        error.response.data || statusText;
      throw new Error(
        `Erro ao enviar CPF: ${status} ${statusText} - ${errorMessage}`,
      );
    } else if (error.request) {
      throw new Error(
        "Erro de rede ao enviar CPF. Verifique sua conexão.",
      );
    } else {
      throw new Error(`Erro ao enviar CPF: ${error.message}`);
    }
  }
}
